import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'verification_assessment_window'

export const dataPointDefinition = {
  retracedId: 'verification_assessment_window',
  name: 'Verification/Assessment Window:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'vd-e10',
      number: 'VD-VERI-6',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'vd-e10-opt',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '',
      machineShowHide: '',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'vd_e10_opt',
      name: 'vd-e10-opt',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['vd_e10_opt'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-e10', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34610,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
